export default __webpack_public_path__ + "images/347c808d3a90e99523964bd601ef8a5d.jpg";